import { Dispatch, FormEvent, SetStateAction, useState } from "react";
import { useNavigate } from "react-router-dom";

import { UserType } from "../../../../../../constants";
import { inviteUserToJoinOrganisation } from "../../../../../../service/identity";
import { ServiceError, Status } from "../../../../../../service/Shared";
import { useAuth } from "../../../../../../useAuth";
import { useIsLoadingWrapper } from "../../../../../../utils";
import { Toast } from "../../../../../../widget";

interface UseSendInvitationFormReturnData {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  errors: ServiceError[] | undefined;
  isHandleSubmitLoading: boolean;
  currentUserType: UserType;
  setFirstName: Dispatch<SetStateAction<string>>;
  setLastName: Dispatch<SetStateAction<string>>;
  setEmail: Dispatch<SetStateAction<string>>;
  setRole: Dispatch<SetStateAction<string>>;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  handleCancel: () => void;
}

export const useSendInvitationForm = (userSettingsRoute: string): UseSendInvitationFormReturnData => {
  const navigate = useNavigate();
  const { currentOrganisationUuid, currentUserType } = useAuth();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [errors, setErrors] = useState<ServiceError[] | undefined>();
  const [isHandleSubmitLoading, setIsHandleSubmitLoading] = useState(false);

  const handleSubmit = useIsLoadingWrapper(async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setErrors([]);

    if (currentOrganisationUuid) {
      const res = await inviteUserToJoinOrganisation({
        organisationUuid: currentOrganisationUuid,
        userFirstName: firstName,
        userLastName: lastName,
        userEmail: email,
        projectUuid: null,
        role,
      });

      if (res.status === Status.Success) {
        Toast.success({ message: "User invitation sent successfully" });
        navigate(userSettingsRoute);
      } else {
        setErrors(res.errors);
      }
    }
  }, setIsHandleSubmitLoading);

  const handleCancel = (): void => {
    navigate(userSettingsRoute);
  };

  return {
    firstName,
    lastName,
    email,
    role,
    errors,
    isHandleSubmitLoading,
    currentUserType,
    setFirstName,
    setLastName,
    setEmail,
    setRole,
    handleSubmit,
    handleCancel,
  };
};
